<div v-if="shouldRenderConfig" v-bind:class="getClassName">
    <button type="button" class="btn btn-primary" v-on:click="setShowUpload(!getShowUpload)">
        {{ $t(name) }}
    </button>    
</div>

